import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';

const prefix = 'itemUnavailableErrorPage';

export function ItemUnavailableErrorPage() {
  const location = useLocation();
  const itemType = location.state?.itemType;
  const header = <FormattedMessage id={`${prefix}.errorMessage`} defaultMessage="The item is no longer available." />;
  const subheader = (
    <FormattedMessage
      id={`${prefix}.errorDescription`}
      defaultMessage="You recently received an email requesting your signature for a recent item.
 This request has since been voided. No further action is needed on your part at this time."
      values={{ itemType: itemType == null ? '' : itemType }}
    />
  );
  const image = '/link-expired.svg';

  return (
    <div className="view-error-page">
      <div className="content">
        <div className="center aligned custom-icon">
          <img className="ui centered small image error-image" src={image} alt="unlink" />
        </div>
      </div>
      <div className="ui hidden divider"></div>
      <div className="custom-header mark">{header}</div>
      <div className="description">
        <p> {subheader}</p>
      </div>
    </div>
  );
}
